import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-12 mb-5" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-12 mb-5" }, null, -1)
const _hoisted_3 = { class: "col-xxl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AEFCHistory = _resolveComponent("AEFCHistory")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_ctx.ccode == 0)
        ? (_openBlock(), _createBlock(_component_AEFCHistory, {
            key: 0,
            "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8"
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}